<header id="header" class="">
  <div id="header-inner">
      <img class="blob-blue-bg mobile" src="assets/img/header/header_mobile_blob_blue.svg" />
      <img class="blob-blue-bg desktop" src="assets/img/header/header_blob_blue.svg" />

      <img class="page-blob page-header2-purple" src="assets/img/blobs/pages/blob_purple.svg" />
      <img class="page-blob page-header2-green" src="assets/img/blobs/pages/blob_green.svg" />
      <img class="page-header2" src="assets/img/pages/page_header_bgd.svg" />
      
      <img class="page-blob blob-white blob-white-secondary1-a" src="assets/img/blobs/blob_white.svg">
      <img class="page-blob blob-white blob-white-secondary1-b" src="assets/img/blobs/blob_white.svg">
      <img class="page-blob blob-white blob-white-secondary1-c" src="assets/img/blobs/blob_white.svg">

      <div class="container">
        <div class="row">
            <div class="col col-6-md offset-md-1 col-left">
                <h1 class="page-title">
                  {{ pageTitle }}
                </h1>

                <p class="page-description">
                  <span *ngFor="let line of pageDescription">{{ line }}</span>
                </p>
            </div>
        </div>
    </div>

  </div>
  <img class="page-blob page-header2-orange" src="assets/img/blobs/pages/blob_orange.svg" />
  <img class="page-blob page-header2-blue" src="assets/img/blobs/pages/blob_blue.svg" />
  <img *ngIf="imageURL" class="services-top" src="{{ imageURL }}" />
  
  <img class="page-blob blob-white blob-white-secondary1-d" src="assets/img/blobs/blob_white.svg">
  <img class="page-blob blob-white blob-white-secondary1-e" src="assets/img/blobs/blob_white.svg">
  <img class="page-blob blob-white blob-white-secondary1-f" src="assets/img/blobs/blob_white.svg">


</header>